import { createSlice } from '@reduxjs/toolkit';
import {
  DEFAULT_LANGUAGE_CODE, DEFAULT_LOCALE, getConformingLocale, getLanguageCodeFromLocale,
} from '../../../widget/app/modules/utils/i18n/getLocale';

const i18nSlice = createSlice({
  name: 'i18n',
  initialState: {
    languageCode: DEFAULT_LANGUAGE_CODE,
    locale: DEFAULT_LOCALE,
  },
  reducers: {
    setLocale: (state, action) => {
      const locale = getConformingLocale(action.payload);
      state.locale = locale;
      state.languageCode = getLanguageCodeFromLocale(locale);
    },
  },
});

const selectLanguageCode = (state) => state.i18n.languageCode;
const selectLocale = (state) => state.i18n.locale;

export { selectLanguageCode, selectLocale };
export const { setLocale } = i18nSlice.actions;
export default i18nSlice.reducer;
